<template>
	<div>
		<button @click="streamPostRequest">Avvia Streaming POST</button>
		<p>Risposta in streaming:</p>
		<pre>{{ streamData }}</pre>
	</div>
</template>

<script>
export default {
	data() {
		return {
			streamData: "",
			authToken: null,
			charIndex: 0,
			responseDate: null,
			typingSpeed: 120,
		};
	},
	mounted() {
		this.authToken = this.$route.query.authToken;
	},
	methods: {
		ontest() {
			const source = new EventSource("/api/teststream");
			source.onmessage = function (event) {
				console.log("Dato ricevuto immediatamente:", event.data);
				// Non dimenticare: event.data è una stringa, devi parsare il JSON
				const data = JSON.parse(event.data);
				console.log(data);
			};
			source.onerror = function (err) {
				console.error("Errore SSE:", err);
			};
		},
		async streamPostRequest() {
			this.streamData = "";
			const url = "/api/teststream";
			// ... postData e headers ...

			try {
				const response = await fetch(url, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						// Assicurati che l'header di Authorization sia corretto qui
						Authorization: "Bearer " + this.authToken,
					},
					//body: JSON.stringify(postData),
				});

				if (!response.ok) {
					throw new Error(`Errore HTTP! stato: ${response.status}`);
				}

				this.streamData = "";
				const reader = response.body.getReader();
				const decoder = new TextDecoder("utf-8");
				let buffer = ""; // <--- Buffer per accumulare i dati incompleti
				let x = true;
				while (x) {
					const { done, value } = await reader.read();

					if (done) {
						console.log("Stream completato.");
						// Elabora qui qualsiasi dato rimasto nel buffer se necessario
						break;
					}

					// 1. Decodifica il nuovo chunk e aggiungilo al buffer.
					// L'opzione { stream: true } è fondamentale per gestire i caratteri multi-byte spezzati.
					buffer += decoder.decode(value, { stream: true });

					let lastEventEnd = 0;
					// let eventEndIndex;

					console.log("Passo Uno");
					this.processaRisposta(buffer);

					// // 2. Cerca il delimitatore SSE '\n\n'
					// while ((eventEndIndex = buffer.indexOf("\n\n", lastEventEnd)) !== -1) {
					// 	// Estrai la singola porzione di evento (che include 'data: {...}')
					// 	const event = buffer.substring(lastEventEnd, eventEndIndex);
					// 	// 3. Elabora l'evento
					// 	this.processSSEEvent(event);

					// 	// Aggiorna l'indice per la prossima ricerca, saltando '\n\n'
					// 	lastEventEnd = eventEndIndex + 2;
					// }

					// 4. Mantieni solo la parte non processata nel buffer
					buffer = buffer.substring(lastEventEnd);
				}
			} catch (error) {
				console.error("Si è verificato un errore durante lo streaming:", error);
			}
		},
		processaRisposta(buffer) {
			console.log("processo la risposta");
			// console.log(buffer);
			if (buffer != undefined) {
				this.responseDate = buffer.split("\n\n");
				this.writeData();
				//console.log(x.length);
			}
		},
		writeData() {
			if (this.charIndex < this.responseDate.length) {
				let linea = this.responseDate[this.charIndex];
				let testo = linea.substring("data: ".length).trim();
				if (testo) {
					console.log(testo);
					let dataObject = JSON.parse(testo);
					this.streamData += dataObject.message.content;
					this.charIndex++;
					setTimeout(this.writeData, this.typingSpeed);
				}
			}
		},
		async processSSEEvent(eventData) {
			console.log("Prova Uno");

			setTimeout(() => {
				console.log("Prova due");
				const dataLine = eventData.split("\n").find((line) => line.startsWith("data: "));

				if (dataLine) {
					const jsonPayload = dataLine.substring("data: ".length).trim();

					try {
						const data = JSON.parse(jsonPayload);

						// 🔴 CORREZIONE CRITICA PER LA REATTIVITÀ 🔴
						// Invece di +=, prova a forzare l'aggiornamento usando un array o una funzione.
						// L'uso diretto di += su una stringa lunga è solitamente reattivo,
						// ma se non funziona, prova una delle due soluzioni seguenti:

						// Soluzione A: Semplice concatenazione (dovrebbe funzionare)
						//this.streamData += JSON.stringify(data) + "\n";
						// 🔴 SOLUZIONE FINALE (se la reattività standard fallisce) 🔴
						// Sposta l'aggiornamento del DOM fuori dal ciclo while/read()
						setTimeout(() => {
							this.streamData += data.message.content;
						}, 0);
					} catch (e) {
						console.error("Errore nel parsing JSON dell'evento:", e, jsonPayload);
					}
				}
			}, 5000);
		},
	},
};
</script>
